import { useBlocker } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

export function useUnsavedChangesGuard(when) {
  const blocker = useBlocker(when);
  const [showModal, setShowModal] = useState(false);
  const hasOpenedRef = useRef(false);

  useEffect(() => {
    if (blocker.state === "blocked" && !hasOpenedRef.current) {
      hasOpenedRef.current = true;

      // defer state update to avoid cascading-render warning
      queueMicrotask(() => {
        setShowModal(true);
      });
    }

    if (blocker.state === "unblocked") {
      hasOpenedRef.current = false;
      setShowModal(false);
    }
  }, [blocker.state]);

  const confirmNavigation = () => {
    hasOpenedRef.current = false;
    setShowModal(false);
    blocker.proceed();
  };

  const cancelNavigation = () => {
    hasOpenedRef.current = false;
    setShowModal(false);
    blocker.reset();
  };

  return {
    showModal,
    confirmNavigation,
    cancelNavigation,
  };
}
